import { ca } from '@cian/analytics';

export const trackPromoSearchSelect = () => {
  ca('eventSite', {
    action: 'Click',
    category: 'Promo',
    label: 'suggest_to_list',
    name: 'oldevent',
    useLastProducts: true,
  });
};
